// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2yYfn","Logo":"Toolbar_Logo__MY9eE","DesktopOnly":"Toolbar_DesktopOnly__39JWC","MobileOnly":"Toolbar_MobileOnly__1BwUX"};